import { FaInstagram } from "react-icons/fa";

type NavigationHeaderItem = {
  name: string;
  href: string;
  external: boolean;
  label: string | null;
};

export const navigationMarketing: NavigationHeaderItem[] = [
  { name: "Home", href: "/", external: false, label: null },
  { name: "Pricing", href: "/pricing", external: false, label: null },

  { name: "FAQ", href: "/faq", external: false, label: null },
  {
    name: "Contact",
    href: "/contact",
    external: false,
    label: null,
  },
  {
    name: "Careers",
    href: "https://careers.audimee.com",
    external: true,
    label: null, // "We're hiring"
  },
  {
    name: "Affiliate",
    href: "https://affiliate.audimee.com",
    external: true,
    label: null,
  },
];

type NavigationFooterItem = {
  name: string;
  href: string;
  external: boolean;
};

export const navigationFooter: NavigationFooterItem[] = [
  { name: "Home", href: "/", external: false },
  { name: "Pricing", href: "/pricing", external: false },
  { name: "Careers", href: "https://careers.audimee.com", external: true },
  { name: "FAQ", href: "/faq", external: false },
  { name: "Contact", href: "/contact", external: false },
  { name: "Tools", href: "/tools", external: false },
  { name: "Blog", href: "/blog", external: false },
  { name: "Terms of use", href: "/terms-of-use", external: false },
  { name: "Privacy policy", href: "/privacy", external: false },
  { name: "Disclaimer", href: "/disclaimer", external: false },
];

export const socialsFooter = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/weareaudimee",
    icon: FaInstagram,
  },
];

export const termsOfUseDataId = "c3837c40-f01c-4b20-8304-f428816b54ab";
export const privacyPolicyDataId = "34c49c51-a95c-41f5-a61a-674969dea9d6";
export const disclaimerDataId = "346cf17b-99da-4a84-82eb-1276d5fcd51f";

export const affiliateLink = "https://affiliate.audimee.com";
